<script context="module">
	//import the variables for mail from setUp
	import { urlAdmin } from './Setup.svelte'
	import { urlTranslate } from './Setup.svelte'

	export const get_translation = async (formData) => {
		try {
			const response = await fetch(urlTranslate, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(formData),
			})
			const dataResponse = await response.json()

			//return the response to the async function of the caller
			return dataResponse
		} catch (e) {
			return { sent: false, code: 'ERROR: es konnte keine Verbindung hergestellt werden', error: e }
		}
	}

	//fetch data from server
	export const admin = async (formData) => {
		try {
			const response = await fetch(urlAdmin, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(formData),
			})
			const dataResponse = await response.json()

			//return the response to the async function of the caller
			return dataResponse
		} catch (e) {
			return { sent: false, code: 'ERROR: es konnte keine Verbindung hergestellt werden', error: e }
		}
	}

	//twilio (send sms and whatsApp)
	export const send_to_twilio = async (cmd, formData) => {
		//the different urls for twilio requests
		let requestUrl
		if (cmd === 'tup') requestUrl = 'https://kybosms-1615.twil.io/tup'
		if (cmd === 'quote') requestUrl = 'https://kybosms-1615.twil.io/quote'
		if (cmd === 'startdesign') requestUrl = 'https://kybosms-1615.twil.io/startdesign'
		if (cmd === 'invoice') requestUrl = 'https://kybosms-1615.twil.io/invoice'

		try {
			const response = await fetch(requestUrl, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(formData),
			})
			const dataResponse = await response.json()

			if (dataResponse) {
				return dataResponse
			}
		} catch (e) {
			return { sent: false, code: 'ERROR: es konnte keine Verbindung hergestellt werden', error: e }
		}
	}
</script>
